import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { PrivacyPage, TermsPage } from "./legal";
import "maplibre-gl/dist/maplibre-gl.css";
import "./styles.css";

const path = window.location.pathname.replace(/\/+$/, "") || "/";
const content = path === "/privacidad" ? <PrivacyPage /> : path === "/terminos" ? <TermsPage /> : <App />;

createRoot(document.getElementById("root")!).render(<StrictMode>{content}</StrictMode>);
